var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
function SettingsImageCard(_a) {
    var src = _a.src, alt = _a.alt, orientation = _a.orientation, onDelete = _a.onDelete;
    var _b = useState(false), errored = _b[0], setErrored = _b[1];
    var orientationClass = orientation ? "settings-image-card--".concat(orientation.toLowerCase()) : "";
    return (_jsxs("div", __assign({ className: "settings-image-card ".concat(orientationClass).trim() }, { children: [src && !errored ? (_jsx("img", { src: src, alt: alt || "imagem", onError: function () { return setErrored(true); } })) : (_jsx("div", __assign({ className: "settings-image-placeholder" }, { children: _jsx(ImageIcon, {}) }))), onDelete && (_jsx("button", __assign({ type: "button", className: "settings-image-delete", onClick: onDelete, "aria-label": "Excluir imagem" }, { children: _jsx(DeleteIcon, { fontSize: "small" }) })))] })));
}
export default SettingsImageCard;
